import { userWorkspaceManager as workspace } from "../../constants/actionTypes";

const INITIAL_STATE = {
  userWorkspaceLabsList: [],
  userWorkspaceListLoading: false,
  userWorkspaceLabTimer: "",
};

const workspaceManager = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case workspace.SET_USER_WORKSPACE_DASHBOARD_LIST:
      return {
        ...state,
        userWorkspaceLabsList: action?.data?.data,
      };
    case workspace.SET_USER_WORKSPACE_DASHBOARD_LIST_ERROR:
      return {
        ...state,
        userWorkspaceLabsList: [],
      };
    case workspace.SET_USER_WORKSPACE_LIST_LOADING:
      return {
        ...state,
        userWorkspaceListLoading: false,
      };
    case workspace.SET_USER_WORKSPACE_LAB_TIMER:
      return {
        ...state,
        userWorkspaceLabTimer: action?.data?.data,
      };
    case workspace.SET_WORKSPACE_VM_STATUS:
      let tempList = state?.userWorkspaceLabsList;
      tempList[0].vm_state = action?.data?.vm_state;
      return {
        ...state,
        userWorkspaceLabsList: tempList,
      };
    default:
      return state;
  }
};

export default workspaceManager;
